import { render, staticRenderFns } from "./ViewKanban.vue?vue&type=template&id=fc49e4ec&scoped=true&"
import script from "./ViewKanban.vue?vue&type=script&lang=ts&"
export * from "./ViewKanban.vue?vue&type=script&lang=ts&"
import style0 from "./ViewKanban.vue?vue&type=style&index=0&id=fc49e4ec&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fc49e4ec",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSpacer } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';
import { VToolbar } from 'vuetify/lib/components/VToolbar';
import { VToolbarTitle } from 'vuetify/lib/components/VToolbar';
installComponents(component, {VCard,VIcon,VSpacer,VTextField,VToolbar,VToolbarTitle})
